/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Draftemail_Description2Inputs */

const en_coinvestments_draftemail_description2 = /** @type {(inputs: Coinvestments_Draftemail_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To and CC are routing only. Access is granted in the section below — never inferred from these fields.`)
};

/**
* | output |
* | --- |
* | "To and CC are routing only. Access is granted in the section below — never inferred from these fields." |
*
* @param {Coinvestments_Draftemail_Description2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_draftemail_description2 = /** @type {((inputs?: Coinvestments_Draftemail_Description2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Draftemail_Description2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_draftemail_description2(inputs)
});
export { coinvestments_draftemail_description2 as "coInvestments_draftEmail_description" }